export default "__VITE_ASSET__1320cf48__"